import { render } from "./DetalleAcceso.vue?vue&type=template&id=2eb5a09f"
import script from "./DetalleAcceso.vue?vue&type=script&lang=js"
export * from "./DetalleAcceso.vue?vue&type=script&lang=js"

import "./DetalleAcceso.vue?vue&type=style&index=0&id=2eb5a09f&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__